import { useTranslation } from "react-i18next";
import { INDUSTRY_STATS, isStatVisible, type IndustryStatId } from "@/data/industryStats";

interface SourcedStatProps {
  id: IndustryStatId;
  className?: string;
}

export const SourcedStat = ({ id, className }: SourcedStatProps) => {
  const { t, i18n } = useTranslation();
  const stat = INDUSTRY_STATS[id];
  if (!stat || !isStatVisible(stat, i18n.language)) return null;

  return (
    <figure className={className} data-testid={`sourced-stat-${id}`}>
      <div className="text-3xl sm:text-4xl font-bold text-primary tracking-tight">{stat.value}</div>
      <figcaption className="mt-3 space-y-2">
        <p className="text-sm sm:text-base text-foreground leading-relaxed">
          {t(`industryStats.stats.${id}.claim`)}
        </p>
        <a
          href={stat.sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block text-xs text-muted-foreground hover:text-primary underline-offset-2 hover:underline"
        >
          {t("industryStats.sourceLabel")}: {stat.sourceName} ({stat.year})
        </a>
      </figcaption>
    </figure>
  );
};

export default SourcedStat;
